export function navigateToDocument(href: string) {
  window.location.assign(href);
}

export function reloadDocument() {
  window.location.reload();
}

export function isAuthRouteHandlerHref(href: string): boolean {
  return ["/sign-in", "/sign-up", "/sign-out"].some(
    (path) =>
      href === path || href.startsWith(`${path}?`) || href.startsWith(`${path}#`),
  );
}

export function requiresPublicDocumentNavigation(href: string): boolean {
  return (
    isAuthRouteHandlerHref(href) ||
    href === "/dashboard" ||
    href.startsWith("/dashboard?") ||
    href.startsWith("/dashboard#") ||
    href.startsWith("/dashboard/")
  );
}
